export const userGeolocationFields = ['country_code', 'country_name'];

export const maintenanceFields = ['maintenance_mode', 'maintenance_message'];
